import config from '@platform/shared/config';
import Axios from 'axios';
import { serviceOptions } from './api.gen';

const axios = Axios.create({
    baseURL: config.base_api_url + '/imap-client',
    headers: {
        'Service-ID': config.serviceId,
        'Filestore-Api-Key': config.apiKeyFileStore,
    },
});

import('@platform/shared/rpc/node-auth')
    .then(({ registerAxiosForAuthHooks }) => {
        return registerAxiosForAuthHooks(axios);
    })
    .catch(console.error);

serviceOptions.axios = axios;
